import { render, staticRenderFns } from "./TrashBigIcon.vue?vue&type=template&id=ea64a398"
import script from "./TrashBigIcon.vue?vue&type=script&lang=js"
export * from "./TrashBigIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports